import React from "react";
import Page from "../Page";
import TitlePage from "../TitlePage";
import { Box, Checkbox, Typography } from "@mui/material";
import "./style.scss";

export default function AddLayout({
  title,
  action,
  inputHead,
  inputRemark,
  bodyTitle,
  bodyAction,
  tableHead,
  tableBody,
  bootomAction,
  dialog,
  cheackAll,
  handleCheckAll,
  tableHeight,
}) {
  let tr = [];
  let td = [];

  for (let i = 0; i < tableBody.length; i++) {
    for (let index = 0; index < Object.keys(tableBody[i]).length; index++) {
      td.push(
        <td key={index} class="text-center" style={{ position: "relative" }}>
          {tableBody[i][`item${index + 1}`]}
        </td>
      );
    }
    tr.push(<tr key={i}>{td}</tr>);
    td = [];
  }
  return (
    <Page>
      <TitlePage title={title} action={action} />

      <Box className="row" sx={{ width: "80%" }}>
        {inputHead?.map((item, i) => {
          return (
            <Box key={i} className="col-lg-5 col-md-6 mt-2">
              <Typography className="labelInput">{item?.name}</Typography>
              {item?.inputComponent}
            </Box>
          );
        })}
        {inputRemark}
      </Box>
      <TitlePage title={bodyTitle} action={bodyAction} />
      <div class="addDetail row">
        <div
          class="col-md-12 table-responsive-sm"
          style={{
            height: tableHeight || "auto",
            overflowX: "auto",
            overflowY: "auto",
          }}
        >
          <table class="table table-borderless" style={{ width: "1800px" }}>
            <thead>
              <tr>
                {tableHead?.map((item, i) => {
                  if (item === "CHECKBOX") {
                    return (
                      <th key={i} class="text-center">
                        <Checkbox
                          checked={cheackAll}
                          onChange={handleCheckAll}
                        />
                      </th>
                    );
                  }
                  return (
                    <th key={i} class="text-center">
                      {item}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody class="">{tr}</tbody>
          </table>
        </div>
      </div>
      <hr class="chr" />
      <div class="row mt-4">
        <div class="col-12">{bootomAction}</div>
      </div>
      {dialog}
    </Page>
  );
}
